import axios from 'axios';
import * as Authentication from "./authenticationAPI";
import * as Bookings from "./bookingsAPI";
import * as FilterRules from "./filterRulesAPI";
import * as Offers from "./offersAPI";
import * as User from "./userAPI";
import * as RequestContract from './requestContractAPI'
import * as Accommodations from './accommodationsAPI'
import * as Homes from "./homesAPI";
import * as HomeServices from "./homeServicesAPI";
import * as HomeServiceJoins from "./homeServiceJoinAPI";
import * as Apartments from "./apartmentsAPI";
import * as Summary from "./summaryAPI";
import * as AlloggiatiAccounts from "./alloggiatiAccountsAPI";
import * as AbitAccounts from "./abitAccountsAPI";
import * as Locations from "./locationsAPI";
import * as Quotes from "./quotesAPI";
import * as Templates from "./templatesAPI";
import * as GoogleAccount from './googleAccountAPI'
import * as RatesAPI from './ratesAPI'
import * as RequestsAPI from './requestAPI'
import * as BookingFinances from './bookingFinancesAPI'


axios.interceptors.response.use(async (response) => {
    // add artificial delay for dev env
    if (process.env.NODE_ENV === 'development') {
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return response;
});

export {
    Authentication,Bookings, FilterRules, Offers, User, RequestContract, Homes, Summary, AlloggiatiAccounts,
    AbitAccounts, HomeServices, HomeServiceJoins, Apartments, Locations, Quotes, Templates, GoogleAccount,
    RatesAPI, Accommodations, RequestsAPI, BookingFinances
};